// Import Dependencies
import React from 'react';

// Import Stylesheet
import styles from './offshoreRates.css';

const OffshoreRates = () => {
    return (
        <p className={styles.message} id="offshore-rates">
            <strong>Note:</strong> Calls to and from this number use our <a href="http://grasshopper.com/international-rates/" target="_blank">off-shore rate schedule</a> and incur additional per-minute fees.
        </p>
    );
};

export default OffshoreRates;
